<template>
    <div>
      <span :style="{ color: status.color, fontWeight: 'bold' }">
        {{ status.icon }} {{ status.label }}
      </span>
      <p style="margin-top: 8px;">{{ status.description }}</p>
    </div>
  </template>
  
  <script setup>
  import { watch, reactive } from "vue";

  import { statusStyles } from "@/utils/statusStyles";
  
  const props = defineProps({
    statusKey: { type: String, required: true }
  });


  
// 반응형 데이터로 상태 저장
const status = reactive({
  ...statusStyles[props.statusKey] || {
    label: "알 수 없음",
    color: "gray",
    icon: "❓",
    description: "알 수 없는 상태입니다."
  }
});

// 상태 변경 감지
watch(
  () => props.statusKey,
  (newStatus) => {
    const updatedStatus = statusStyles[newStatus] || {
      label: "알 수 없음",
      color: "gray",
      icon: "❓",
      description: "알 수 없는 상태입니다."
    };
    Object.assign(status, updatedStatus);
    console.log("Updated status in StatusDisplay:", status);
  }
);
console.log("Status Key:", props.statusKey);
console.log("Status Styles:", statusStyles);
console.log("Resolved Status:", status);

  </script>
  